import styled from 'styled-components/';
import AppCSS from '../../../../utils/styled';

export const Components = {
  EventWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    margin: 0 8px;
    padding: 6px 0;
    max-height: 22px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    width: 8px;
    min-width: 8px;
    height: 8px;
    min-height: 8px;
  `,
  EventDot: styled.div`
    width: 8px;
    height: 8px;
    min-width: 8px;
    ${AppCSS.radiuses.forHeight(8)};
    background-color: ${AppCSS.colors.blues.dark};
  `,
  InsightsWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
  `,
  EventTime: styled.span`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  EventTitle: styled.div`
    ${AppCSS.fonts.label10Bold};
    color: ${AppCSS.colors.black};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `,
};
